module.exports = __webpack_public_path__ + "static/media/placeholder.1eb7fff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/placeholder.jpg
// module id = 1291
// module chunks = 0